import React, {useEffect, useState} from 'react';
import { useData, useDataUpdate } from "../../components/context/DataContext";
import { useMediasizeUpdate } from "../../components/context/MediasizeContext";
import { useAttempts, useAttemptsUpdate } from "../../components/context/AttemptsContext";
import { renderFormattedText } from "../../utils/helpers";
import icnUp from '../../assets/images/icon-up.png';
import icnDown from "../../assets/images/icon-down.png";

import { gaButtonClick, gaQuiz } from '../../utils/gatags';

import './Content.css';
import Footer from '../Footer/Footer';
import AudioPlayer from '../../components/MP3AudioPlayer/MP3AudioPlayer';

import AnimateHeight from 'react-animate-height';
import DragDrop from '../../components/DragDrop/DragDrop';

const Content = () => {
    // const [data, setData] = useState(null);
    // const [hide, setHide] = useState(false);
    // const audioModalSet = useModalUpdate(true);
    // const setModalContent = (_sec) => {
    //     audioModalSet(true);
    //     gaCapture(_sec);
    // }

    const json = useData();
    const setDataState = useDataUpdate();

    const mediaSizeSet = useMediasizeUpdate();
    const [height, setHeight] = useState(0);
    const [att, setAtt] = useState(0);

    const userAttempts = useAttempts();
    const setUserAttempts = useAttemptsUpdate();

    // const gaCapture = (_idx) => {
    //     const modalEl = document.getElementsByClassName("btn" + _idx);
    //         gaButtonClick(
    //         "Modal-click",
    //         "click",
    //         modalEl[0].children[1].innerText + " - popup displayed"
    //     )
    // }

   
    const addCounter = () => {
        setUserAttempts(userAttempts+1)
        setAtt(att+1)
    }

    useEffect(() => {
        fetch('./content.json'
            ,{
            headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
            }
            )
            .then(function(response){
                return response.json();
                
            })
            .then(function(dataJson) {
                // setData(dataJson);
                setDataState(dataJson);
        });
        

        // detect resize
        const handleResize = () => {
              if (parseInt(window.innerWidth) < 768) {
                mediaSizeSet(false);
              } else {
                mediaSizeSet(true);
                // eqHeights();
              }
            }
            handleResize();
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
            
    }, []) 


    if (!json) {
        return (
            <div className="loading-elem">
                <p>Loading data...</p>;
            </div>
        )
    }



    return (
        <div className="App">
            <div id="component-574087">
                <div className="content">
                    <div className="swirl"></div>
                    <div className="dd-content">
                        <h1>{renderFormattedText(json && json.content[0].heading)}</h1>
                        <AudioPlayer />
                    </div>
                    <div className="dd-content no-pad btm-mg-10">
                        <div aria-expanded={height !== 0}
                            aria-controls="example-panel"
                            onClick={() => {
                                setHeight(height === 0 ? 200 : 0)
                                gaButtonClick("button click", "toggle transcript");
                                }
                                
                            } 
                            className={ height === 0 ? "transcript-btn" : "transcript-btn tsb-open"}>
                            <div className="transcript-btn-label">
                                <div className={ height === 0 ? "transcript-lbl-icon" : "transcript-lbl-icon tbl-open"}></div>
                                <h2 className={ height === 0 ? "" : "white-txt"}>{json && renderFormattedText(json.content[0].transcripthead)}</h2>
                            </div>
                            <div className={ height === 0 ? "transcript-btn-icon" : "transcript-btn-icon tbi-open"}></div>
                        </div>
                        <AnimateHeight
                            id="transcript-panel"
                            duration={500}
                            height={height} // see props documentation below
                            >
                            <div className="transcript">{json && renderFormattedText(json.content[0].transcript)}</div>
                            <div className="scroll-ico"></div>
                        </AnimateHeight>
                    </div>
                    <div className="dd-q-wrap">
                        <div id="note1" className="note">
                            <h2 id="n1-head1"></h2>
                            <div className="note-icon">
                                <img src={icnDown} alt="Triangle icon" />
                                <h3 id="n1-head2"></h3>
                            </div>
                            <div id="note1copy"></div>
                        </div>
                        <div className="dd-question">
                            <h2>{json && renderFormattedText(json.content[0].ddhead)}</h2>
                            <h3>{json && renderFormattedText(json.content[0].ddinstruction)}</h3>
                            <DragDrop counterclick={addCounter} />
                        </div>
                        <div id="note2" className="note">
                            <h2 id="n2-head1"></h2>
                            <div className="note-icon">
                                <img src={icnUp} alt="Triangle icon" />
                                <h3 id="n2-head2"></h3>
                            </div>
                            <div id="note2copy"></div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
        );
    };
    
    export default Content;